module.exports = __webpack_public_path__ + "static/media/icon-documents.ad6c95e5.svg";